









































































































































































































































































































import pdf from "vue-pdf";
import { Component, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BeratBadan from "@/components/pemeriksaan/assesmen/BeratBadan.vue";
import GolonganDarah from "@/components/pemeriksaan/assesmen/GolonganDarah.vue";
import TekananDarah from "@/components/pemeriksaan/assesmen/TekananDarah.vue";
import TinggiBadan from "@/components/pemeriksaan/assesmen/TinggiBadan.vue";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import { appModule } from "@/store/modules/app";
import { storeAssesmenRalan } from "@/store/modules/asesmenralan";
import { storeDokter } from "@/store/modules/dokter";
import { storePasien } from "@/store/modules/pasien";
import StoreSuketTatoTindik from "@/store/modules/SuketTatoTindik";
import { userModule } from "@/store/modules/user";
import type { SuketBaseWithRelationship } from "@/types/suket_tato-tindik";
@Component({
	components: {
		CardModalTtd,
		BaseSuketCard,
		pdf,
		BeratBadan,
		TinggiBadan,
		TekananDarah,
		GolonganDarah,
	},
})
export default class SuketTatoTindikTabPage extends BaseSuketTabPage {
	@Prop() declare readonly register: string | number;
	allowedUnit = ["09", "2G"];
	suketSvc = new CommonSuket(EnSuketCategory.TatoTindik);
	suketStore = StoreSuketTatoTindik;
	register_id = this.register;
	pasien_rm = this.pasien.rm;
	unit_id = this.user.unit_id;
	nama = this.pasien.nama;
	tglLahir = this.pasien.tgl_lahir;
	surat_date = new Date();
	signee_user_id = this.user.id;
	creator_user_id = this.user.id;
	alamat_type = "ktp";
	tato = this.dataSuket?.content.tato || false;
	tindik = this.dataSuket?.content.tindik || false;
	td = this.dataSuket?.content.td || this.tensiAsesmen || "";
	tb = this.dataSuket?.content.tb || this.tbAsesmen || "";
	bb = this.dataSuket?.content.bb || this.bbAsesmen || "";
	nadi = this.dataSuket?.content.nadi || this.nadiAsesmen || "";
	imt = this.dataSuket?.content.imt || "";
	gol_darah = this.dataSuket?.content.gol_darah || this.statePasien.gol_darah;
	kegunaan = null;
	validasi = [(v) => !!v || "*Kolom ini harus diisi"];
	saving = false;
	showInputTujuan = true;
	loadedRatio = 0;
	golDarahOptions = [
		{
			text: "A",
			value: "A",
		},
		{
			text: "B",
			value: "B",
		},
		{
			text: "AB",
			value: "AB",
		},
		{
			text: "O",
			value: "O",
		},
		{
			text: "A+",
			value: "A+",
		},
		{
			text: "A-",
			value: "A-",
		},
		{
			text: "B+",
			value: "B+",
		},
		{
			text: "B-",
			value: "B-",
		},
		{
			text: "AB+",
			value: "AB+",
		},
		{
			text: "AB-",
			value: "AB-",
		},
		{
			text: "O+",
			value: "O+",
		},
		{
			text: "O-",
			value: "O-",
		},
	];

	get stateAsesmenAwal(): any {
		return storeAssesmenRalan.asesmenAwal;
	}
	get tensiAsesmen() {
		const tv = this.stateAsesmenAwal?.tanda_vital;
		const sistole = tv?.sistole ?? null;
		const diastole = tv?.diastole ?? null;
		return sistole || diastole ? `${sistole}/${diastole}` : null;
	}
	get tbAsesmen() {
		return this.stateAsesmenAwal?.antropometri?.tinggi_badan ?? null;
	}
	get bbAsesmen() {
		return this.stateAsesmenAwal?.antropometri?.berat_badan ?? null;
	}
	get nadiAsesmen() {
		return this.stateAsesmenAwal?.tanda_vital?.frekuensi_nadi ?? null;
	}
	get pdfUrl() {
		return this.dataSuket
			? this.getSuketPdfUrl(EnSuketCategory.TatoTindik, this.dataSuket.id)
			: null;
	}
	get pasien() {
		return storePasien.identitasPasien;
	}
	get alamatOptions() {
		const opts = [
			{
				id: "ktp",
				name: this.pasien.alamat,
				category: "Alamat KTP",
			},
		];

		if (this.pasien.alamat_domisili) {
			opts.push({
				id: "domisili",
				name: this.pasien.alamat_domisili,
				category: "Alamat Domisili",
			});
		}

		return opts;
	}
	get statePasien() {
		return storePasien.identitasPasien;
	}
	get user() {
		return userModule.user;
	}
	get input() {
		return {
			register_id: this.register_id,
			pasien_rm: this.pasien_rm,
			unit_id: this.unit_id,
			content: {
				alamat_type: this.alamat_type,
				tato: this.tato,
				tindik: this.tindik,
				td: this.td,
				n: this.nadi,
				tb: this.tb,
				bb: this.bb,
				imt: this.imt,
				gol_darah: this.gol_darah,
				kegunaan: this.kegunaan,
			},
			surat_date: this.surat_date,
			signee_user_id: this.signee_user_id,
			creator_user_id: this.creator_user_id,
		};
	}
	get listDokter() {
		return storeDokter.list;
	}
	get canSign() {
		return this.user.id == this.signee_user_id;
	}

	mounted() {
		this.register_id = this.dataSuket?.register_id || this.register;
		this.pasien_rm = this.dataSuket?.pasien_rm || this.pasien.rm;
		this.unit_id = this.dataSuket?.unit_id || this.user.unit_id;
		this.pasien_rm = this.pasien.rm;
		this.nama = this.pasien.nama;
		this.tglLahir = this.pasien.tgl_lahir;
		this.tato = this.dataSuket?.content.tato || false;
		this.tindik = this.dataSuket?.content.tindik || false;
		this.td = this.dataSuket?.content.td || this.tensiAsesmen || "";
		this.tb = this.dataSuket?.content.tb || this.tbAsesmen || "";
		this.bb = this.dataSuket?.content.bb || this.bbAsesmen || "";
		this.nadi = this.dataSuket?.content.nadi || this.nadiAsesmen || "";
		this.imt = this.dataSuket?.content.imt || "";
		this.gol_darah =
			this.dataSuket?.content.gol_darah || this.statePasien.gol_darah;
		this.surat_date = this.dataSuket?.surat_date || new Date();
		this.signee_user_id = this.dataSuket?.signee_user_id || this.user.id;
		this.creator_user_id = this.dataSuket?.creator_user_id || this.user.id;
		this.alamat_type = this.dataSuket?.content.alamat_type;
		this.kegunaan = this.dataSuket?.content.kegunaan;
	}
	save() {
		if (!this.saving) {
			this.saving = true;
			const action = this.dataSuket
				? this.suketSvc.update(this.dataSuket.id, this.input)
				: this.suketSvc.create(this.input);
			action
				.then(() => {
					if (this.canSign) {
						this.showSignatureModal();
					}
					appModule.NoticeDelay("Berhasil Simpan");
					this.close();
					StoreSuketTatoTindik.getSuketByRegister(this.register);
				})
				.finally(() => {
					this.saving = false;
				});
		}
	}
	setImt() {
		if (!this.tb && !this.bb) {
			this.imt = null;
		} else if (this.bb < 1 || this.tb < 1) {
			this.imt = null;
		} else {
			this.imt = (this.bb / (this.tb / 100) ** 2).toFixed(2);
		}
	}
	ketImt(v) {
		if (v >= 30) {
			return "(Obesitas)";
		} else if (v >= 25) {
			return "(Overweight)";
		} else if (v >= 18.5) {
			return "(Normal)";
		} else if (v >= 0) {
			return "(Underweight)";
		} else {
			return null;
		}
	}
	close() {
		this.expandInput = false;
	}
	setBb(v) {
		this.bb = v;
	}
	setTb(v) {
		this.tb = v;
	}

	@Watch("dataSuket")
	changeDataSuket(val: SuketBaseWithRelationship) {
		if (val) {
			this.register_id = val.register_id;
			this.pasien_rm = val.pasien_rm.toString();
			this.unit_id = val.unit_id;
			this.alamat_type = val.content.alamat_type;
			this.tato = val.content.tato;
			this.tindik = val.content.tindik;
			this.td = val.content.td;
			this.nadi = val.content.n;
			this.tb = val.content.tb;
			this.bb = val.content.bb;
			this.imt = val.content.imt;
			this.gol_darah = val.content.gol_darah;
			this.kegunaan = val.content.kegunaan;
			this.surat_date = val.surat_date;
			this.signee_user_id = val.signee_user_id;
			this.creator_user_id = val.creator_user_id;
		} else {
			this.register_id = this.register;
			this.pasien_rm = this.pasien.rm;
			this.unit_id = this.user.unit_id;
			this.alamat_type = "ktp";
			this.tato = false;
			this.tindik = false;
			this.td = this.tensiAsesmen || "";
			this.tb = this.tbAsesmen || "";
			this.bb = this.bbAsesmen || "";
			this.nadi = this.nadiAsesmen || "";
			this.imt = "";
			this.gol_darah = this.statePasien.gol_darah;
			this.kegunaan = null;
			this.kegunaan = null;
			this.surat_date = new Date();
			this.signee_user_id = this.user.id;
			this.creator_user_id = this.user.id;
		}
	}
	@Watch("bb")
	watchBb(v) {
		this.setImt();
	}
	@Watch("tb")
	watchTb(v) {
		this.setImt();
	}
	@Watch("loadedRatio")
	changeLoadedRatio(val) {
		console.log("change loaded ratio", val);
	}
}
